<template>
  <div class="rate-radio">
    <div class="ui-radio" v-for="(item,index) in content">
      <a class="rate-off" :class="selected[index]?'rate-on rate-ontxt':''" @click="handleRadio(index)"></a>
      <div class="label">{{item}}</div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    content: Array
  },
  data() {
    return {
      selected:[false, false, false, false, false]
    }
  },
  methods:{
    handleRadio: function(num) {
      let self = this
      self.selected.map(function(item,index){
        if(index==num){
          self.$set(self.selected,index,true)
        }else{
          self.$set(self.selected,index,false)
        }
      })
      self.$emit('listenToChildEvent',num)
    }
  }
}
</script>
<style lang="stylus" scoped>
  .rate-radio
    display:inline-block
    overflow:hidden
    margin: 0.1rem 0 0 0.2rem;
    .ui-radio
        background: none repeat scroll 0 0 #fff;
        font-size: 16px;
        float:left;
      .rate-off
        width: 21px;
        height: 21px;
        text-decoration: none;
        border-radius: 30px;
        color: #333;
        border: 1px solid #cacece;
        cursor: default;
        display: inline-block;
        background: #fafafa;
        line-height: 19px;
        text-align: center;
        float:left;
      .rate-on
        background-color: #53a4f4 !important;
        border: 1px solid #53a4f4;
        position: relative;
        color: #fff;
      .rate-ontxt:after
        content: ' ';
        width: 10px;
        height: 10px;
        border-radius: 50px;
        position: absolute;
        top: 5px;
        background: #fff;
        text-shadow: 0px;
        left: 5px;
        font-size: 32px;
      .label
        display: block;
        padding:0 0.2rem 0.1rem 0;
        cursor: pointer;
        float:left;
</style>
